import { withInstall } from '../utils';
import './index.less';
import _Slider from './index.vue';

export const TlbsSlider = withInstall(_Slider);

export default TlbsSlider;
